// Cubic
export const OutCubic = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
export const InCubic = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
export const InOutCubic = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

// Quint
export const OutQuint = 'cubic-bezier(0.23, 1, 0.32, 1)';
export const InQuint = 'cubic-bezier(0.755, 0.05, 0.855, 0.06)';
export const InOutQuint = 'cubic-bezier(0.86, 0, 0.07, 1)';

// Expo
export const OutExpo = 'cubic-bezier(0.19, 1, 0.22, 1)';
export const InExpo = 'cubic-bezier(0.95, 0.05, 0.795, 0.035)';
export const InOutExpo = 'cubic-bezier(1, 0, 0, 1)';

// Circ
export const OutCirc = 'cubic-bezier(0.075, 0.82, 0.165, 1)';
export const InCirc = 'cubic-bezier(0.6, 0.04, 0.98, 0.335)';
export const InOutCirc = 'cubic-bezier(0.785, 0.135, 0.15, 0.86)';

// Back (bounce)
export const OutBack = 'cubic-bezier(0.175, 0.885, 0.32, 1.275)';
export const OutBackMod = 'cubic-bezier(.63,.05,.26,1.2)';
